function StatCard({ item }) {
  return (
    <article className="glass-card stat-card">
      <strong>{item.value}</strong>
      <h3>{item.label}</h3>
      <p>{item.note}</p>
    </article>
  );
}

export default StatCard;
